import React from 'react';
import {CANVAS_SCROLL_SIZE_UPDATED} from '@packages/systems/designer/actions';
import {dispatchInDesigner} from '../utils/dispatchInDesigner';
import {
  CanvasScrollStateShape,
  getCurrentCanvasScrollSizes,
} from '@packages/systems/designer/canvas';

/**
 * Side effects that are needed to be done to make our Custom Canvas Scroll work
 */
export const useCanvasAppScrollResize = ({
  canvasScrollHeight,
  canvasScrollWidth,
  pageId,
}: {
  canvasScrollHeight: CanvasScrollStateShape['canvasScrollHeight'];
  canvasScrollWidth: CanvasScrollStateShape['canvasScrollWidth'];
  pageId: string | undefined;
}) => {
  const scrollTimerRef = React.useRef<NodeJS.Timeout | null>(null);

  const clearScrollTimeout = () => {
    scrollTimerRef.current && clearTimeout(scrollTimerRef.current);
  };

  React.useEffect(() => {
    const updateCanvasScrollSize = () => {
      if (pageId !== undefined) {
        const {scrollWidth, scrollHeight} = getCurrentCanvasScrollSizes(window);

        // Only updateCanvasScrollSize if there was actually a change with scrollHeight or scrollWidth
        if (
          canvasScrollHeight !== scrollHeight ||
          canvasScrollWidth !== scrollWidth
        ) {
          dispatchInDesigner({
            type: CANVAS_SCROLL_SIZE_UPDATED,
            payload: {
              scrollHeight,
              scrollWidth,
            },
          });
        }
      }

      /**
       * Similarly to what we do in the "normal" Canvas, we need to check periodically
       * to see if the scrollHeight or scrollWidth has changed. If that's the case,
       * we need to update the scrollHeight and scrollWidth in Flux.
       */
      scrollTimerRef.current = setTimeout(updateCanvasScrollSize, 200);
    };

    clearScrollTimeout();
    updateCanvasScrollSize();

    return () => {
      clearScrollTimeout();
    };
  }, [pageId, canvasScrollHeight, canvasScrollWidth]);
};
